import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react';

export class AdiantamentoDocumentos extends Component {
  static propTypes = {
    documentos: PropTypes.object
  };

  renderDocumentos = doc => {
    let key =
      doc.get('id') + '_' + doc.get('numero') + '_' + doc.get('fornecedor');

    return (
      <tr key={key} data={doc}>
        <td>{doc.get('numero')}</td>
        <td>{DateUtils.formatDateTimeShort(doc.get('data'))}</td>
        <td>{doc.get('tipoDocumentoFiscal')}</td>
        <td>{doc.get('tipoSerieDocumentoFiscal')}</td>
        <td className="rigth">
          <NumberFormatter value={doc.get('valor')} />
        </td>
      </tr>
    );
  };

  render() {
    const { documentos } = this.props;

    if (!documentos) {
      return <div className="info">Não há documentos.</div>;
    }

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={documentos.isEmpty()} text="Não há documentos.">
            <tr>
              <th>Número</th>
              <th>Data</th>
              <th>Tipo Documento Fiscal</th>
              <th>Tipo Série</th>
              <th>Valor</th>
            </tr>
          </TableHeader>
          <tbody>{documentos.map(this.renderDocumentos)}</tbody>
        </table>
      </div>
    );
  }
}

export default AdiantamentoDocumentos;
